
<template>
<div class="criteria-list">
   <div class="criteria-list__heading">
      Search criteria:
   </div>
   <div class="criteria-list__list">
      <span v-for="(filter, key) in criterias" :key="filter.id">
         <span class="criteria-list__item" v-if="Array.isArray(filter)">
            {{ getKeyName(key) | decamelize | capitalize }} 
            <span class="criteria-list__subitem" >{{ formatArray(filter)}}</span>
         </span>
         <span class="criteria-list__item" v-if="!Array.isArray(filter) && !isDate(filter) && notInHiddenCriterias(key)">
            {{ getKeyName(key,filter) | decamelize | capitalize }} {{ getOrderByName(key,filter) }}
         </span>
         <span class="criteria-list__item criteria-list__item" v-if="isDate(filter)">
            {{displayDateAsCriteriaSearch(key, filter) }}
         </span>
      </span>
   </div>
   <div class="criteria-list__change-criteria-btn" v-on:click="toggleForm" tabindex="0">Change search criteria<i class="icon-edit"></i></div>
</div>
</template>

<script>

import _ from 'lodash';
import moment from 'moment'

export default {
   name: 'CriteriaList',
   props: ['filters', 'showForm', 'schema'],
   data() {
      return {
         keyNames: [],
         criterias: []
      }
   },
   methods: {
      toggleForm() {
         this.showForm();
      },
      getOrderByName(key, filter) {
         if (key == "sortBy") {
            if (this.keyNames) {
               var propName = filter.replace('Order', '');
               for (var i = 0; i < this.keyNames.length; i++) {
                  if (this.keyNames[i].Key == propName) {
                     return this.keyNames[i].Name.replace(":", '');
                  }
               }
            }
         }
        if (key == "textOfTheRecommendation") {
            return '';
        }

         return filter;
      },
      getKeyName(key, filter) {
         if (this.keyNames) {
            for (var i = 0; i < this.keyNames.length; i++) {
               if (this.keyNames[i].Key == key) {
                  return this.keyNames[i].Name;
               }
            }
         }

         if (key == 'sortBy') {
            return key + ':';
         }

         return key;
      },
      formatArray(array) {
         var result = '';
         if (Array.isArray(array) && array.length > 0) {
            if (!isNaN(parseInt(array[0])) && array.length == 2) {
               result = array[0] + ' - ' + array[1];
            } else {
               result = array.join(', ');
            }
         }
         return result;
      },
      handleKeyNamesChange() {
         if (this.schema) {
            var keyNames = []
            for (var i = 0; i < this.schema.length; i++) {
               var item = this.schema[i];
               keyNames.push({
                  Key: item.Key,
                  Name: item.Name,
                  Order: item.Order
               });
            }
            this.keyNames = keyNames;
            this.criterias = this.sortByKeys(this.filters, this.sortByCriteriaComparer)
         }
      },
      sortByCriteriaComparer(o, key) {
         var vm = this;

         // page and sortby should be at the beginning
         // of the criterias list
         if(!(key == "page" || key == "sortBy")) {
            
            var criteria =  _.find(vm.keyNames, function(kn){ return kn.Key == key })

            if(criteria) {
               return criteria.Order;
            }
            
            // if no fieled is configured in main form
            // add criteria at the end of list
            return 999;
         }
         else {
            return -1;
         }
      },
      sortByKeys: function (obj, comparator) {
         var keys = _.sortBy(_.keys(obj), function (key) {
               return comparator ? comparator(obj[key], key) : key;
         });
      
         return _.zipObject(keys, _.map(keys, function (key) {
            return obj[key];
         }));
      },
      isDate(value) {
         return moment(value, this.$timeConfig.formats.ISO8601Format, true).isValid();
      },
      displayDateAsCriteriaSearch(key, filter) {
         if (key == "dayOfElection") {
            key = "Election Date";
         }
         var day = moment(filter).format(this.$timeConfig.formats.forMomentShortDate);

         return `${key}: ${day}`;
      },
      notInHiddenCriterias(key) {
         return key != 'onlyOtherBeneficiaries'
      }
   },
   watch: {
      schema: {
         handler: function () {
            this.handleKeyNamesChange();
         },
         deep: true
      },
      filters: {
         handler: function () {
            this.handleKeyNamesChange();
         },
         deep: true,
      }
   },
   filters: {
      decamelize(value, separator) {
         separator = typeof separator === 'undefined' ? ' ' : separator;

         return value
            .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
            .toLowerCase();
      },
      capitalize: function (value) {
         if (!value) return ''
         value = value.toString()
         return value.charAt(0).toUpperCase() + value.slice(1)
      }
   }
}
</script>

<style lang="scss" scoped>
    @import "src/scss/variables";

    .criteria-list {
        display: flex;
        justify-content: space-between;
        border-width: 2px;
        border-style: solid;       
        border-radius: 5px;
        padding: 30px;
        margin: 15px 0 30px 0;
        position: relative;

        @media (max-width: 767px) {
            padding: 25px 20px;
            flex-direction: column;
        }

        &__heading {
            position: absolute;
            left: 20px;
            top: 0;
            transform: translateY(-50%);
            padding: 0 10px;

            @media (max-width: 991px) {
                left: 10px;
            }
        }

        &__list {
            padding-right: 20px;
            flex: 1 1 auto;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            @media (max-width: 767px) {
                padding-right: 0;
                flex: 1 1 auto;
            }
        }

    &__item {
        font-family: $main-font;
        display: inline-block;
        padding: 1px 10px;       
        border-width: 2px;
        border-style: solid;       
        border-radius: 5px;
        letter-spacing: 0.1em;
        margin: 0 5px 10px 0;
    }

    &__subitem:last-child:after {
        content: '';
    }

    &__change-criteria-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        padding: 0 20px;
        border-width: 2px;
        border-style: solid;
        border-radius: 5px;     
        text-decoration: none;
        flex-shrink: 0;
        outline: none;
        transition: all 0.2s;
        cursor: pointer;
        
        .icon-edit {
            margin-left: 10px;
        }

        @media (max-width: 767px) {
            width: 100%;
            margin-top: 5px;
            flex: 1 1 auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/CriteriaList.vue